import React from "react";
import EditAlarmData from "src/views/alarms/EditAlarmData";
import { Connect } from "aws-amplify-react";
import { graphqlOperation } from "aws-amplify";
import * as mutations from "src/graphql/mutations";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Alert,
  Badge,
} from "reactstrap";

/**
 * AlarmNomozakiView
 *
 * @author Thais Watanabe
 */
const AlarmNomozakiView = (props) => {
  const { alarms } = props;

  // AlertView
  const AlertView = ({ order }) => (
    <Alert
      className="alert-with-icon"
      color={
        order.includes("禁止")
          ? "danger"
          : order.includes("遠隔")
          ? "info"
          : "success"
      }
    >
      <span className="tim-icons icon-alert-circle-exc" data-notify="icon" />
      <span data-notify="message">{order}</span>
    </Alert>
  );
  return (
    <>
      <Row>
        {alarms.map((alarm, i) => (
          <Col lg={Math.round(12 / alarms.length)} key={i}>
            <Card className="card">
              <CardHeader>
                <Row className="align-items-center">
                  <Col className="text-left">
                    <CardTitle tag="h4">
                      <Badge
                        color={
                          alarm.state === "Emergency" || "Stop"
                            ? "warning"
                            : "info"
                        }
                      >
                        {alarm.state}
                      </Badge>{" "}
                      {alarm.id} - {alarm.name}
                    </CardTitle>
                  </Col>
                  <Col>
                    <Connect
                      mutation={graphqlOperation(mutations.updateAlarmNomozaki)}
                    >
                      {({ mutation }) => (
                        <EditAlarmData
                          onUpdate={mutation}
                          windfarm={"野母崎"}
                          alarm={alarm}
                        />
                      )}
                    </Connect>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {alarm.order != null ? <AlertView order={alarm.order} /> : ""}

                <h4>
                  {alarm.interaction != null
                    ? alarm.interaction
                        .split("\n")
                        .map((item, i) => <p key={i}>{item}</p>)
                    : "対応ありません"}
                </h4>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <Row>
        <Col xs="12">
          <Card className="card">
            <CardHeader>
              <Row>
                <Col className="text-left">
                  <CardTitle tag="h4">検索詳細</CardTitle>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table className="nomozaki-table tablesorter w-auto" responsive>
                <thead className="text-primary text-center">
                  <tr>
                    <th rowSpan="3">ID</th>
                    <th rowSpan="3" style={{ width: "8%" }}>
                      アラーム名
                    </th>
                    <th rowSpan="3" style={{ width: "20%" }}>
                      内容
                    </th>
                    <th colSpan="3">停止動作</th>
                    <th colSpan="5">故障停止</th>
                    <th colSpan="4">警報</th>
                    <th rowSpan="3" style={{ width: "8%" }}>
                      対応
                    </th>
                    <th rowSpan="3" style={{ width: "8%" }}>
                      リセット2
                    </th>
                  </tr>
                  <tr>
                    <th rowSpan="2">回数</th>
                    <th rowSpan="2">時間(分)</th>
                    <th rowSpan="2">停止</th>
                    <th rowSpan="2">重故障</th>
                    <th rowSpan="2">軽故障</th>
                    <th colSpan="3">リセット</th>
                    <th rowSpan="2">警報</th>
                    <th colSpan="3">リセット</th>
                  </tr>
                  <tr>
                    <th>機側</th>
                    <th>遠隔</th>
                    <th>自動</th>
                    <th>機側</th>
                    <th>遠隔</th>
                    <th>自動</th>
                  </tr>
                </thead>
                <tbody>
                  {alarms.map((alarm, i) => (
                    <tr key={i}>
                      <td>{alarm.id}</td>
                      <td>{alarm.name}</td>
                      <td>{alarm.contents}</td>
                      <td>{alarm.stopFrequency}</td>
                      <td>{alarm.stopTime}</td>
                      <td>{alarm.stopInterruption}</td>
                      <td>{alarm.errorHeavy}</td>
                      <td>{alarm.errorLight}</td>
                      <td>{alarm.errorResetLocal}</td>
                      <td>{alarm.errorResetRemote}</td>
                      <td>{alarm.errorResetAuto}</td>
                      <td>{alarm.alarmWarning}</td>
                      <td>{alarm.alarmResetLocal}</td>
                      <td>{alarm.alarmResetRemote}</td>
                      <td>{alarm.alarmResetAuto}</td>
                      <td>{alarm.interaction}</td>
                      <td>{alarm.order}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AlarmNomozakiView;
